/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React from 'react';

import styled from "styled-components";
import {Form, OverlayTrigger, Tooltip} from "react-bootstrap";
import tokens from '../../styles/design-tokens';
import SparklesIcon from "../../../organization/explore/filters/components/assets/SparklesIcon";

const FormLabel = (props) => {
    const {
        children,
        isPreview,
        infoText
    } = props;

    return (
        <LabelHeader>
            <LabelContent>
                <StyledLabel>{children}</StyledLabel>

                {isPreview && (
                    <PreviewBadge>
                        <SparklesIcon size="12px" />
                        <span style={{ marginLeft: 5, textTransform: 'capitalize' }}>Preview</span>
                    </PreviewBadge>
                )}
            </LabelContent>

            {infoText && (
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>{infoText}</Tooltip>}
                >
                    <InfoIcon>
                        ℹ
                    </InfoIcon>
                </OverlayTrigger>
            )}
        </LabelHeader>

    )
}

export default FormLabel;

const LabelHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
    width: 100%;
`;

const LabelContent = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

const StyledLabel = styled(Form.Label)`
    font-weight: ${tokens.typography.fontWeight.medium};
    color: ${tokens.colors.primary};
    margin-bottom: 0;
    text-transform: uppercase;
    font-size: ${tokens.typography.fontSize.xs};
`;

const InfoIcon = styled.span`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.8;

    &:hover {
        opacity: 1;
    }

    background-color: ${tokens.colors.primary};
    color: white;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    font-size: ${tokens.typography.fontSize.xs};
    font-weight: ${tokens.typography.fontWeight.bold};
    font-style: italic;
    font-family: serif;
`;

export const PreviewBadge = styled.span`
    display: inline-flex;
    align-items: center;
    background-color: ${tokens.colors['gray-100']};
    color: ${tokens.colors.cyan};
    font-size: 10px;
    font-weight: 600;
    padding: 4px 8px;
    border-radius: 2px;
    line-height: 1;
    border: 1px solid ${tokens.colors.cyan};
`;
